import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationAuthorizationRoutingModule } from './authentication-authorization-routing.module';
import { SignInComponent } from '../sign-in/sign-in.component';
import { UnauthorizedUserComponent } from '../unauthorized-user/unauthorized-user.component';
import { MaterialModule } from '../shared/material.module';
import { CoreModule } from '../core/core.module';
import { CommonModule } from '@angular/common';  
import { MaintenanceComponent } from '../maintenance/maintenance.component';

@NgModule({
declarations:[
  SignInComponent,
  UnauthorizedUserComponent,
  MaintenanceComponent
],
imports:[
  AuthenticationAuthorizationRoutingModule,
  MaterialModule,
  CoreModule,
  CommonModule
]

})
export class AuthenticationAuthorizationModule { }
